export default __webpack_public_path__ + "static/media/WinterClothes_11.123bde28.png";